import styled from 'styled-components'

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconContainer = (styled.div<{
  $containerRadius: number
  $backgroundColor: string
}>`
  width: ${({ $containerRadius }) => $containerRadius}px;
  height: ${({ $containerRadius }) => $containerRadius}px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
